import axios from "axios";

const instance = axios.create({
  baseURL: "https://reactive-hamburger.firebaseio.com/"
});

export default instance;



// WEBPACK FOOTER //
// ./src/axios-orders.js